'use strict';

var toastr = require('toastr');
var _ = require('lodash');
var ConfigurationEntityController = function ConfigurationEntityController(dataRetrieverService, $scope, configurationEntityService, configurationLoaderService, staticDataService) {
  dataRetrieverService.getDataRetriever('ENTITY_SCREEN', 'configuration-entity-mode').setCustomSearchCriteriaRules([]);
  var reloadEntities = staticDataService.loadEntities;
  function save(rows) {
    return configurationEntityService.saveConfigurationEntity(rows).then(reloadEntities);
  }
  $scope.saveChanges = function (event, rows) {
    try {
      validate(rows);
      save(rows).then(function () {
        $scope.$broadcast('configuration-entity:saveSuccess');
      });
    } catch (e) {
      toastr.error(e);
    }
  };
  $scope.loadedSuccessful = function (event, data) {
    configurationEntityService.setId(data.domain.id);
  };
  $scope.removeEntity = function (event, data) {
    var rowsToRemove = data.rows.filter(function (row) {
      var bool = true;
      for (var i = 0, k = data.fields.length; i < k; i++) {
        bool = row[data.fields[i].name] && bool;
      }
      return bool;
    });
    configurationEntityService.removeEntity(rowsToRemove).then(reloadEntities).then(function () {
      $scope.$broadcast('grid:dataChanged');
    });
  };
  function validate(rows) {
    _.each(rows, function (row) {
      if (row.hasOwnProperty('description') && row.description.length > 40) {
        throw new Error('\'Description \' can\'t be longer than 40 chars.');
      }
    });
  }
};
ConfigurationEntityController.$inject = ['DataRetrieverService', '$scope', 'ConfigurationEntityService', 'ConfigurationLoaderService', 'StaticDataService'];
module.exports = ConfigurationEntityController;